import * as React from 'react';
import classnames from 'classnames';
import { Button } from '@grandvisionhq/common';
import { Email } from '@grandvisionhq/forms';

class EmailForm extends React.Component {
    render() {
        const { email  } = this.state;
        const { dataT , buttonLabel , isButtonDisabled , isButtonLoading , className , children , emailLabel , emailErrorLabel , renderOptIns ,  } = this.props;
        return /*#__PURE__*/ React.createElement("form", {
            onSubmit: this.handleSubmit,
            className: classnames('email-form', className),
            noValidate: true,
            "data-t": dataT
        }, /*#__PURE__*/ React.createElement(Email, {
            "data-t": "email",
            required: true,
            label: emailLabel,
            errorMessage: emailErrorLabel,
            onChange: this.setEmail,
            hideAsteriskSign: true
        }), renderOptIns, /*#__PURE__*/ React.createElement(Button, {
            "data-t": "submit",
            type: "submit",
            disabled: isButtonDisabled || !email.isValid,
            isLoading: isButtonLoading,
            caption: buttonLabel,
            className: "email-form__button"
        }), children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            email: {
                value: '',
                isValid: undefined
            }
        };
        this.setEmail = (state)=>{
            this.setState(()=>({
                    email: {
                        value: state.value,
                        isValid: state.isValid
                    }
                })
            );
        };
        this.handleSubmit = (event)=>{
            event.preventDefault();
            const { email  } = this.state;
            const { onSubmit  } = this.props;
            if (email.isValid === true) {
                onSubmit(email.value);
            }
        };
    }
}
var EmailForm$1 = EmailForm;

export { EmailForm$1 as default };
//# sourceMappingURL=EmailForm.js.map
